import { render, staticRenderFns } from "./EmailTemplates.vue?vue&type=template&id=4c42e858&scoped=true&"
import script from "./EmailTemplates.vue?vue&type=script&lang=js&"
export * from "./EmailTemplates.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplates.vue?vue&type=style&index=0&id=4c42e858&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c42e858",
  null
  
)

export default component.exports